import { formatNumber } from "./number";

export const formatDuration = (hours: number, digits = 1) =>
  formatNumber(hours, { minimumFractionDigits: digits, maximumFractionDigits: digits });
